import React, { useContext, useEffect, useState } from "react";
import LoadingElement from "../components/elements/Loading.Element";
import PlayerGoalAssistCard from "../components/elements/PlayerGoalAssistCard.Component";
import { DB_REF } from "../constants/DB";
import { firebaseContext } from "../contexts/FirebaseContext";
import img from "../img/practice_img.jpg";
import { Player } from "../interfaces/Player.Interface";
import imgLogo from "../svg/logo_word.svg";
import "./Main.Styles.scss";

export default function MainScreen() {
  const [loading, setLoading] = useState(true);
  const [goalPlayers, setGoalPlayers] = useState<Player[]>([]);
  const [assistsPlayers, setAssistsPlayers] = useState<Player[]>([]);
  const firebase = useContext(firebaseContext);

  useEffect(() => {
    const getPlayer = async (playerId: string) => {
      const player = await firebase
        .firestore()
        .collection(DB_REF.players)
        .doc(playerId)
        .get();
      if (player.exists) {
        return player.data() as Player;
      } else {
        return null;
      }
    };

    const getTop3GoalScorers = async () => {
      try {
        const seasonData = await firebase
          .firestore()
          .collection(DB_REF.currentSeason)
          .doc("season")
          .get();
        const season = seasonData.exists ? seasonData.data()!.no : 0;

        const top3Goals = await firebase
          .firestore()
          .collection(DB_REF.seasonStats)
          .orderBy("goals")
          .where("season", "==", season)
          .limitToLast(3)
          .get();
        setGoalPlayers([]);
        top3Goals.forEach(async (ele) => {
          const player = await getPlayer(ele.data().playerId);
          if (player) {
            const p: Player = {
              ...player,
              stats: {
                ...(ele.data() as any),
              },
            };

            setGoalPlayers((old) => [...old, p]);
          }
        });

        getTop3Assists(season);
      } catch (err) {
        console.log(err);
      }
    };

    const getTop3Assists = async (season: number) => {
      const top3Assists = await firebase
        .firestore()
        .collection(DB_REF.seasonStats)
        .orderBy("assists")
        .where("season", "==", season)
        .limitToLast(3)
        .get();
      setAssistsPlayers([]);
      top3Assists.forEach(async (ele) => {
        const player = await getPlayer(ele.data().playerId);
        if (player) {
          const p: Player = {
            ...player,
            stats: {
              ...(ele.data() as any),
            },
          };

          setAssistsPlayers((old) => [...old, p]);
        }
      });

      setLoading(false);
    };

    try {
      getTop3GoalScorers();
    } catch (err) {
      console.log(err);
    }
  }, []);

  const renderBanner = () => {
    return (
      <div className="banner-container">
        <div className="banner-text-container">
          <h2>We are,</h2>
          <h1>Mustangs FC</h1>
          <p>Look up, get up, and never give up</p>
        </div>
        <img src={img} alt="" />
        <div></div>
      </div>
    );
  };

  const renderInfoBar = () => {
    return (
      <div className="info-bar-container row">
        <div className="paragraph-container col-xs-6">
          <p>
            Our club is from Nugawela, Sri Lanka and we have a Junior Team and a
            Senior Team. We play in divisional and prvincial tournaments right
            now and we are aiming to go to the National level.
          </p>
        </div>
        <div className="image-container col-xs-6">
          <img className="col-md-8" src={imgLogo} alt="" />
        </div>
      </div>
    );
  };

  const renderTopAssists = () => {
    return assistsPlayers
      .slice(0)
      .reverse()
      .map((ele, index) => {
        return <PlayerGoalAssistCard player={ele} key={index} type="Assists" />;
      });
  };

  const renderTopGoals = () => {
    return goalPlayers
      .slice(0)
      .reverse()
      .map((ele, index) => {
        return <PlayerGoalAssistCard player={ele} key={index} type="Goals" />;
      });
  };

  const topPlayerInfo = () => {
    return (
      <div className="top-player-container">
        <h1 className="title">MOST GOALS - Top 3</h1>
        <div className="row">{renderTopGoals()}</div>
      </div>
    );
  };

  const topAssistsInfo = () => {
    return (
      <div className="top-asists-container">
        <h1 className="title">MOST ASSISTS - Top 3</h1>
        <div className="row">{renderTopAssists()}</div>
      </div>
    );
  };

  if (loading) {
    return <LoadingElement />;
  }

  return (
    <div className="main-screen">
      {renderBanner()}
      {renderInfoBar()}
      {topPlayerInfo()}
      {topAssistsInfo()}
    </div>
  );
}
